import React, { useEffect } from "react";
import Header from "../layouts/Header";
import Banner from "../layouts/Banner";
import Footer from "../layouts/Footer";
import usePageMeta from "../Helpers/usePageMeta";

const Careers = () => {
  usePageMeta({
    title: "Careers | TZ Creation",
    description:
      "TZ Creation is a remote-first team. Not actively hiring right now, but reach out for future opportunities.",
    path: "/careers",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Banner />
      <Footer />
    </>
  );
};

export default Careers;
